<template>
  <div>
    <h3>New Lesson</h3>

    <vx-card no-shadow class="mt-8">
      <h2 class="mb-6">Information</h2>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Title</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <i8n-input label="" placeholder="Title..." :content.sync="title" class="w-full" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Description</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <i8n-textarea placeholder="Description..." :content.sync="description" class="w-full" />
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Required Performance Score</span>
        </div>
        <div class="vx-col">
          <vs-input v-validate="'numeric'" name="requiredPerformanceScore" v-model="requiredPerformanceScore" />
          <div class="text-danger text-sm" v-show="errors.has('requiredPerformanceScore')">{{ errors.first('requiredPerformanceScore') }}</div>
        </div>
      </div>
    </vx-card>

    <!-- Add Lesson Button -->
    <div class="flex flex-wrap items-center justify-end mt-12">
      <vs-button
        @click="addLesson"
        id="save-button"
        class="ml-auto mr-auto mt-2"
        size="large"
      >Add Lesson</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      surveyId: '',
      moduleId: '',

      // Lesson information
      title: '',
      description: '',
      requiredPerformanceScore: 0
    };
  },
  methods: {
    addLesson: function() {
      this.$vs.loading()

      const payload = {
        title: this.title,
        description: this.description,
        requiredPerformanceScore: parseInt(this.requiredPerformanceScore),
      };

      const url = process.env.VUE_APP_API +'/Surveys/4/' + this.surveyId + '/modules/' + this.moduleId + '/lessons';

      this.$http.post(url, payload)
        .then(resp => {
          if (resp.data.success === true) {
            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Lesson added'
            });

            this.$router.push({ name: 'admin-survey-online-training-lesson', params: { surveyId: this.surveyId, moduleId: this.moduleId, lessonId: resp.data.lessonId } }).catch(() => {})
          } else {
            console.log(resp.data.error);

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not add lesson: ' + resp.data.error
            });
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    }
  },
  created() {
    this.surveyId = this.$route.params.surveyId;
    this.moduleId = this.$route.params.moduleId;
  }
};
</script>

<style lang="scss" scoped>
.horizontal-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
</style>